// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import siteMessage from "@insite/client-framework/SiteMessage";

const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");
const alphanumericRegexp = /^[a-zA-Z0-9_-\s]*$/;
const phoneRegexp = /^\d{3}\-\d{3}\-\d+$/;

export const maxLengthAttr = {
    qty: 6,
};

export const maxQtyValue = 999999;

export const validateAlphanumericNumbers = (number: string) => {
    let error = siteMessage("Custom_OnlyAlphaNumericAllowed");
    if (!number) {
        return error;
    }
    const m = alphanumericRegexp.exec(number);

    if (m !== null) {
        // The result can be accessed through the `m`-variable.
        m.forEach((match, groupIndex) => {
            error = "";
        });
    }
    return error;
};

export const validateEmail = (email: string) => {
    const error = emailRegexp.test(email) ? "" : siteMessage("Custom_EmailIsNotValid");
    return error;
};

export const formatPhone = (phoneNumberString: string) => {
    const cleaned = `${phoneNumberString}`.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d+)$/);
    if (match) {
        return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return phoneNumberString;
};

export const validateLength = (value: string, length: number) => {
    return value.length === length ? "" : siteMessage("Custom_LengthIsNotValid");
};

export const validatePhone = (phone: string) => {
    let error = siteMessage("Custom_PhoneIsNotValid");
    if (!phone) {
        return error;
    }
    const m = phoneRegexp.exec(phone);

    if (m !== null) {
        // The result can be accessed through the `m`-variable.
        m.forEach((match, groupIndex) => {
            error = "";
        });
    }
    return error;
};
